export default (theme) => ({
  mainContent: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(4),
    minHeight: "100vh",
    backgroundColor: theme.palette.background.default,
    marginLeft: 180,
    [theme.breakpoints.down("xs")]: {
      marginLeft: 0,
      marginTop: 80,
    },
  },
  formContainer: {
    maxWidth: 600,
    margin: "0 auto",
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12,
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
  },
  headerContainer: {
    marginBottom: theme.spacing(4),
    textAlign: "center",
  },
  title: {
    marginBottom: theme.spacing(2),
    color: theme.palette.darkGrey.main,
    fontSize: "1.75rem",
    fontWeight: 600,
  },
  subtitle: {
    color: theme.palette.text.secondary,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
  },
  multiSelect: {
    width: "100%",
    marginBottom: 0,
  },
  input: {
    width: "100%",
  },
  submitButton: {
    marginTop: 0,
    "&.Mui-focusVisible": {
      outline: `2px solid ${theme.palette.secondary.main}`,
      outlineOffset: 2,
    },
    padding: theme.spacing(1.5),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  "@media (max-width: 600px)": {
    formContainer: {
      padding: theme.spacing(2),
    },
    title: {
      fontSize: "1.5rem",
    },
  },
});
